export const getUsernameLetterALias = (userName: string): string => userName
    ?.split(' ')
    ?.map(symbol => symbol[0])
    .join('')
    ?.toUpperCase();
